module.exports = __webpack_public_path__ + "static/media/FETAVE-in.78edc942.svg";